export default __webpack_public_path__ + "static/essence-vanilla-white-bd2386cd75d4ee40362cf5a4746231b2.svg";